<template>
  <div class="v-checkbox"
       :class="{
      'v-checkbox--is-dirty': isDirty,
      'v-checkbox--is-disabled': disabled,
      'v-checkbox--has-label': Object.keys(options).length || this.$slots.default
    }"
       data-vv-value-path="model"
       :data-vv-as="label">
    <label class="v-form__label" v-if="label && label !=''" style="margin-right: 10px;">
      {{label}}
    </label>
    <template v-if="sort">
      <label :for="name + key"
             class="v-checkbox__item v-checkbox__item--is-radio"
             v-for="(option, key) in sortProperties(options, sortBy, order)"
             :key="option[0]"
             @click="stateChange">
        <input @change="$emit('input', model), $emit('change', model)"
               :name="name"
               type="radio"
               :value="option[0]"
               v-model="model"
               :disabled="disabled"
               :id="name + option[0]">
        <div class="v-checkbox__indicator"></div>
        <span v-html='option[1]'></span>

      </label>
    </template>

    <div class="v-checkbox__item--is-radio-wrap dib-vt-hlp" v-else>
      <label :for="name + key" 
             class="v-checkbox__item v-checkbox__item--is-radio"
             v-for="(option, key) in options"
             :key="key"
             @click="stateChange">

        <input @change="$emit('input', model), $emit('change', model)"
               :name="name"
               type="radio"
               :value="key"
               v-model="model"
               :disabled="disabled"
               :id="name + key">
        <div class="v-checkbox__indicator"></div>
        <span v-if="boldLabel && checkedBold"><strong v-html='option'></strong></span>
        <span v-html='option' v-else></span>

      </label>
    </div>


    <input type="hidden"
           :name="name"
           v-model="model"
           v-validate="rules">

    <div class="v-input__error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'

  export default {
    data() {
      return {
        model: this.value
      }
    },
    computed: {
      isDirty() {
        return !!this.model
      }
    },
    mixins: [field],
    methods: {
      stateChange(event) {
        event.preventDefault();
        
        var innerInputValue = event.target.closest('label').querySelector('input').value;
        this.model = this.model === innerInputValue ? null : innerInputValue;
      },
      sortProperties(obj, sortBy, order) {
        var sortable = [];
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            sortable.push([key, obj[key]]);
          }
        }
        if (sortBy == 'key') {
          sortable.sort(function (a, b) {
            var x = parseInt(a[0]),
              y = parseInt(b[0]);
            return order == "desc" ? (x > y ? -1 : x < y ? 1 : 0) : (x < y ? -1 : x > y ? 1 : 0);
          });
        } else if (sortBy == 'custom') {
          sortable = this.customOrder;
        } else {
          sortable.sort(function (a, b) {
            var x = a[1].toLowerCase(),
              y = b[1].toLowerCase();
            return order == "desc" ? (x > y ? -1 : x < y ? 1 : 0) : (x < y ? -1 : x > y ? 1 : 0);
          });
        }
        return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
      }
    },
    props: {
      options: {
        default: () => { return {} },
        type: [Object, Array]
      },
      label: {
        default: '',
        type: String
      },
      sort: {
        default: false,
        type: Boolean
      },
      sortBy: {
        default: 'key',
        type: String
      },
      order: {
        default: 'asc',
        type: String
      },
      customOrder: {
        default: () => { return {} },
        type: [Object, Array]
      },
      boldLabel: {
        default: false,
        type: Boolean,
      },
      checkedBold: {
        default: false,
        type: [Boolean, String, Number, Array],
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VRadios.vue